import { render, staticRenderFns } from "./UpdateToken.vue?vue&type=template&id=31121586"
import script from "./UpdateToken.vue?vue&type=script&lang=js"
export * from "./UpdateToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports